/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  GetThreeSixtyEvaluationReportRequest,
  GetThreeSixtyEvaluationRequest,
  ThreeSixtyEvaluationDto,
  ThreeSixtyEvaluationViewModel,
  ThreeSixtyEvaluationReportViewModel,
  SaveThreeSixtyEvaluationRequest,
} from './models';

/**
 * ThreeSixtyEvaluationApi - API class
 */
export class ThreeSixtyEvaluationApi extends LinqService {

  /**
   * Creates a new ThreeSixtyEvaluationApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: ThreeSixtyEvaluationDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/GetAsync`;
    let query = this.createQuery<ThreeSixtyEvaluationDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param request 
   */
  getThreeSixtyEvaluation(request?: GetThreeSixtyEvaluationRequest, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/GetThreeSixtyEvaluation`;
    let query = this.createQuery<ThreeSixtyEvaluationViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = request;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param request 
   */
  getThreeSixtyEvaluationReport(request?: GetThreeSixtyEvaluationReportRequest, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/GetThreeSixtyEvaluationReport`;
    let query = this.createQuery<ThreeSixtyEvaluationReportViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = request;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/GetTranslatedAsync`;
    let query = this.createQuery<ThreeSixtyEvaluationDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/List`;
    let query = this.createQuery<ThreeSixtyEvaluationDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/ListTranslated`;
    let query = this.createQuery<ThreeSixtyEvaluationDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: ThreeSixtyEvaluationDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param request 
   */
  saveThreeSixtyEvaluation(request?: SaveThreeSixtyEvaluationRequest, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyEvaluation/SaveThreeSixtyEvaluation`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = request;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
